import axios from 'axios'

// Definimos la ruta de la api
const ApiAnunciantes = 'gestion-anunciantes/php/api/'

export default {
	getPermisos: () => {
		return axios.get(ApiAnunciantes + 'get-permisos.php')
	},
	buscar: (filtro) => {
		return axios.post(ApiAnunciantes + 'get-buscar.php', filtro)
	},
	getAnunciante: (idAnunciante) => {
		return axios.get(ApiAnunciantes + 'get-anunciante.php?ID=' + idAnunciante)
	},
	setAnunciante: (datos) => {
		return axios.post(ApiAnunciantes + 'set-anunciante.php', datos)
	},
	setFichero: (formData) => {
		return axios.post(ApiAnunciantes + 'set-fichero.php', formData)
	},
	delFichero: (datos) => {
		return axios.post(ApiAnunciantes + 'del-fichero.php', datos)
	}
}



// WEBPACK FOOTER //
// ./src/modulos/gestion-anunciantes/vue/services/api.js